export const generateContentsList = () => {
	let html = ''
	const el = document.querySelector('[data-article]')

	if (!el) return

	const headings = el?.querySelectorAll('[data-article-content] h3')
	const contents = el?.querySelector('[data-article-contents] ul')

	if (!headings.length) return

	headings.forEach((heading, i) => {
		heading.id = `heading-${i}`
		html += `<li><a class="font-caption" href="#heading-${i}">${ heading.innerHTML }</a></li>`
	})

	contents.innerHTML = html

}

export default () => {}